import React from 'react';
import { makeStyles } from 'tss-react/mui';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import ExitToApp from '@mui/icons-material/ExitToApp';

import logo from '../../public/lesbonsartisansdef.png';

const useStyles = makeStyles()({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 0,
  },
  img: {
    paddingLeft: 16,
  },
});


const Header = ({
  navigate, deconnexion
}) => {
  const { classes } = useStyles();
  return (
    <AppBar
      position="relative"
      color="default"
      enableColorOnDark
    >
      <Toolbar className={classes.toolbar}>
        <img
          src={logo}
          alt="logo"
          onClick={() => navigate('/')}
          className={classes.img}
          width={100}
        />
        <Button color="primary" onClick={() => deconnexion()}>
          <ExitToApp />
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
